import { render, staticRenderFns } from "./GroupDetailCell.vue?vue&type=template&id=54275165&scoped=true&"
import script from "./GroupDetailCell.vue?vue&type=script&lang=js&"
export * from "./GroupDetailCell.vue?vue&type=script&lang=js&"
import style0 from "./GroupDetailCell.vue?vue&type=style&index=0&id=54275165&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54275165",
  null
  
)

export default component.exports